/**
 * Raised when Okta authentication succeeded but the backend has no Core.Users record to
 * link the account to (HTTP 404 / PROFILE_NOT_FOUND from ImportUserProfileAsync).
 *
 * This is deterministic - retrying or falling back to a cached profile will not help, so the
 * user is shown the reason instead of being returned to the login screen.
 */
export class ProfileNotFoundError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ProfileNotFoundError';
    Object.setPrototypeOf(this, ProfileNotFoundError.prototype);
  }
}
